import {
  ORDER_LOGISTICS_KIND,
  STAFF_ORDER_LOGISTICS_LABEL_KEYS,
} from '@nebalkon-workspace/cabinet-core';
import { OrderStatuses, OrderTypes } from '@nebalkon-workspace/order-api';

/** Фильтр типа заказа в списке staff-кабинета. */
export type StaffOrderKindFilter =
  | 'all'
  | 'pickup'
  | 'delivery'
  | 'self_dropoff'
  | 'self_pickup';

/** Тип заказа для виджета статистики на главной staff-кабинета. */
export type StaffOrderHomeKindFilter = Exclude<StaffOrderKindFilter, 'all'>;

/** Фильтр по статусу заказа в UI staff-кабинета. */
export type StaffOrderStatusFilter =
  | 'all'
  | 'new'
  | 'in_process'
  | 'pending'
  | 'in_work'
  | 'in_transit'
  | 'stored'
  | 'completed'
  | 'canceled';

export const STAFF_ORDER_KIND_FILTERS: {
  id: StaffOrderKindFilter;
  labelKey: string;
}[] = [
  { id: 'all', labelKey: 'admin.storageRequests.filterKindAll' },
  {
    id: OrderTypes.Pickup,
    labelKey:
      STAFF_ORDER_LOGISTICS_LABEL_KEYS[ORDER_LOGISTICS_KIND.PickupMovers].short,
  },
  {
    id: 'self_dropoff',
    labelKey:
      STAFF_ORDER_LOGISTICS_LABEL_KEYS[ORDER_LOGISTICS_KIND.SelfDropoff].short,
  },
  {
    id: OrderTypes.Delivery,
    labelKey:
      STAFF_ORDER_LOGISTICS_LABEL_KEYS[ORDER_LOGISTICS_KIND.DeliveryMovers]
        .short,
  },
  {
    id: 'self_pickup',
    labelKey:
      STAFF_ORDER_LOGISTICS_LABEL_KEYS[ORDER_LOGISTICS_KIND.SelfPickup].short,
  },
];

export const STAFF_ORDER_STATUS_FILTERS: {
  id: StaffOrderStatusFilter;
  labelKey: string;
}[] = [
  { id: 'all', labelKey: 'admin.storageRequests.filterAll' },
  { id: OrderStatuses.New, labelKey: 'admin.storageRequests.orderStatusNew' },
  {
    id: OrderStatuses.InProcess,
    labelKey: 'admin.storageRequests.orderStatusInProcess',
  },
  { id: OrderStatuses.Pending, labelKey: 'admin.storageRequests.orderStatusPending' },
  { id: OrderStatuses.InWork, labelKey: 'admin.storageRequests.orderStatusInWork' },
  {
    id: OrderStatuses.InTransit,
    labelKey: 'admin.storageRequests.orderStatusInTransit',
  },
  { id: OrderStatuses.Stored, labelKey: 'admin.storageRequests.orderStatusStored' },
  {
    id: OrderStatuses.Completed,
    labelKey: 'admin.storageRequests.filterOrderCompleted',
  },
  {
    id: OrderStatuses.Canceled,
    labelKey: 'admin.storageRequests.filterOrderCancelled',
  },
];

export const STAFF_ORDER_STATUS_FILTER_IDS = STAFF_ORDER_STATUS_FILTERS.filter(
  (f) => f.id !== 'all',
).map((f) => f.id as Exclude<StaffOrderStatusFilter, 'all'>);

export type StaffOrderHomeStatusFilter = Extract<
  StaffOrderStatusFilter,
  'new' | 'in_process'
>;

export type StaffOrderHomeKindStatItem = {
  id: StaffOrderHomeKindFilter;
  labelKey: string;
};

export type StaffOrderHomeStatusStatItem = {
  id: StaffOrderHomeStatusFilter;
  labelKey: string;
};

/** Статусы для виджета на главной staff-кабинета (только требующие внимания). */
export const STAFF_ORDER_HOME_STATUS_FILTERS: StaffOrderHomeStatusStatItem[] = [
  { id: OrderStatuses.New, labelKey: 'admin.storageRequests.orderStatusNew' },
  {
    id: OrderStatuses.InProcess,
    labelKey: 'admin.storageRequests.orderStatusInProcess',
  },
];

export const STAFF_ORDER_HOME_KIND_FILTER_IDS: StaffOrderHomeKindFilter[] =
  STAFF_ORDER_KIND_FILTERS.filter(
    (f): f is { id: StaffOrderHomeKindFilter; labelKey: string } => f.id !== 'all',
  ).map((f) => f.id);

export const STAFF_ORDER_HOME_KIND_STATS: StaffOrderHomeKindStatItem[] =
  STAFF_ORDER_KIND_FILTERS.filter(
    (f): f is StaffOrderHomeKindStatItem => f.id !== 'all',
  );

export const STAFF_ORDER_HOME_STATUS_FILTER_IDS =
  STAFF_ORDER_HOME_STATUS_FILTERS.map((f) => f.id);
